import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackLink from "@/components/BackLink";

// Routes where a global Back link would be redundant or distracting
const HIDE_BACK_ON = new Set(["/", "/contact", "/solutions", "/demos", "/how-it-works"]);

export default function PublicLayout() {
  const { pathname } = useLocation();
  const showBack = !HIDE_BACK_ON.has(pathname) && !pathname.match(/^\/(privacy|terms)$/);
  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]" data-testid="public-layout">
      <Header />
      {showBack && (
        <div className="app-container pt-4 pb-1">
          <BackLink />
        </div>
      )}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
